export default [
  'Haupt',
  'Blatt',
  'Ausdruck',
  'Blau',
  'Schelle',
  'Pilot',
  'Riemen',
  'Punkt',
  'Morgenstern',
  'Würfel',
  'Watt',
  'Loch',
  'Riegel',
  'Tag',
  'Laser',
  'Boot',
  'Berg',
  'Birne',
  'Schloss',
  'Glocke',
  'Horst',
  'Wurf',
  'Bindung',
  'Busch',
  'Ring',
  'Golf',
  'Uhr',
  'Funken',
  'Maus',
  'Rasen',
  'Hollywood',
  'Rost',
  'New York',
  'Ninja',
  'Steuer',
  'Indien',
  'Mittel',
  'Nagel',
  'Bayern',
  'Fleck',
  'Mini',
  'Atlantis',
  'Orange',
  'Platte',
  'Horn',
  'Flügel',
  'Meer',
  'Ente',
  'Leben',
  'Rock',
  'Griechenland',
  'Fuss',
  'Mangel',
  'Schotten',
  'Dietrich',
  'Schein',
  'Apfel',
  'Glück',
  'Bär',
  'Pferd',
  'Schalter',
  'Weide',
  'Moskau',
  'Riese',
  'Mark',
  'Herz',
  'Decke',
  'Wand',
  'Rute',
  'Koch',
  'Stock',
  'Schale',
  'Leim',
  'Hamburger',
  'Alien',
  'Aufzug',
  'Seite',
  'Bogen',
  'Königin',
  'Washington',
  'Spiel',
  'Brause',
  'Himalaja',
  'Hand',
  'Flur',
  'Shakespeare',
  'Lösung',
  'Känguru',
  'Pflaster',
  'Bein',
  'Krone',
  'Korn',
  'Tod',
  'Maler',
  'Kanal',
  'Reif',
  'Korb',
  'Fliege',
  'Gabel',
  'Mal',
  'Skelett',
  'Rücken',
  'Ball',
  'Atlas',
  'Polizei',
  'Stempel',
  'Schiff',
  'Demo',
  'Stuhl',
  'Jäger',
  'Barren',
  'Muschel',
  'Vorsatz',
  'Hubschrauber',
  'Osten',
  'Katze',
  'Zelle',
  'Peitsche',
  'Fessel',
  'Hund',
  'Zeit',
  'Kiwi',
  'London',
  'Pyramide',
  'Dame',
  'Roulette',
  'Schule',
  'Brötchen',
  'Berliner',
  'Jahr',
  'Scheibe',
  'Kohle',
  'Mund',
  'Eis',
  'Börse',
  'Feder',
  'Saturn',
  'Verband',
  'Pass',
  'Schuh',
  'Schimmel',
  'Linie',
  'Boxer',
  'Wolkenkratzer',
  'Verein',
  'Luxemburg',
  'Kraft',
  'Rom',
  'Krebs',
  'Knopf',
  'Gut',
  'Loge',
  'Kreuz',
  'Umzug',
  'Lehrer',
  'Bett',
  'Viertel',
  'Tokio',
  'Toast',
  'England',
  'Pension',
  'Taste',
  'Zug',
  'Finger',
  'Flasche',
  'Schlange',
  'Schnee',
  'Po',
  'Theater',
  'Flöte',
  'Kunde',
  'Zylinder',
  'Ägypten',
  'Oktopus',
  'Batterie',
  'Kamm',
  'Stern',
  'Bremse',
  'Kirche',
  'Fuchs',
  'Lakritze',
  'Fackel',
  'Nuss',
  'Gold',
  'Takt',
  'Strudel',
  'Doktor',
  'Glas',
  'Käfer',
  'Mandel',
  'Pol',
  'Pfeife',
  'Brücke',
  'Kapelle',
  'Zitrone',
  'Abgabe',
  'Pistole',
  'Wal',
  'Leiter',
  'Gürtel',
  'Hahn',
  'Geschoss',
  'Blüte',
  'Fläche',
  'Hut',
  'Bauer',
  'Fisch',
  'Limousine',
  'Linse',
  'Landung',
  'Mond',
  'Star',
  'Tisch',
  'Station',
  'Arm',
  'Bock',
  'Messer',
  'Tempo',
  'Elfenbein',
  'Laster',
  'Melone',
  'Welle',
  'Film',
  'Geist',
  'Kippe',
  'Deutschland',
  'Löffel',
  'Futter',
  'Staat',
  'Schneemann',
  'Europa',
  'Mühle',
  'Australien',
  'Jet',
  'Inka',
  'Millionär',
  'Becken',
  'Niete',
  'Wasser',
  'Bart',
  'Spinne',
  'Tor',
  'Fest',
  'Maschine',
  'Note',
  'Römer',
  'Teleskop',
  'Drossel',
  'Anwalt',
  'Schokolade',
  'Peking',
  'Zahn',
  'Wanze',
  'Daumen',
  'Leuchte',
  'Bau',
  'Quelle',
  'China',
  'Kapitän',
  'Mikroskop',
  'Erde',
  'Amerikaner',
  'Schuppen',
  'Mutter',
  'Netz',
  'Schirm',
  'Kiefer',
  'Wind',
  'Strauss',
  'Löwe',
  'Satz',
  'Öl',
  'Rolle',
  'Kreis',
  'Harz',
  'Absatz',
  'Strom',
  'Bulle',
  'Turm',
  'Drache',
  'Afrika',
  'Krieg',
  'Alpen',
  'Honig',
  'Frankreich',
  'Bombe',
  'Winnetou',
  'Kasino',
  'Mexiko',
  'Zentaur',
  'Messe',
  'Superheld',
  'Ton',
  'Fallschirm',
  'Stamm',
  'Schnabeltier',
  'Brand',
  'Gesicht',
  'Lager',
  'Strand',
  'Fall',
  'Forscher',
  'Hering',
  'Tanz',
  'Sekretär',
  'Karotte',
  'Drucker',
  'Krankheit',
  'Bahn',
  'Spion',
  'Tafel',
  'Prinzessin',
  'Bar',
  'Genie',
  'Quartett',
  'Dieb',
  'Torte',
  'Oper',
  'Tau',
  'Ketchup',
  'Blinker',
  'Nacht',
  'Stift',
  'Auge',
  'Grund',
  'Luft',
  'Kater',
  'Hase',
  'Matte',
  'Bank',
  'Kerze',
  'Gras',
  'Wirtschaft',
  'Auflauf',
  'Dichtung',
  'Zwerg',
  'Gehalt',
  'Wald',
  'Chor',
  'Lümmel',
  'Auto',
  'Feige',
  'Burg',
  'Erika',
  'Ritter',
  'Chemie',
  'Dinosaurier',
  'Optik',
  'Pirat',
  'Strasse',
  'Hupe',
  'Essen',
  'Pinguin',
  'Siegel',
  'Adler',
  'Antarktis',
  'Einhorn',
  'Läufer',
  'Konzert',
  'Loch Ness',
  'Feuer',
  'Kiel',
  'Taucher',
  'Iris',
  'Hexe',
  'Bund',
  'Moos',
  'Botschaft',
  'Heide',
  'Nadel',
  'Engel',
  'Mine',
  'König',
  'Mast',
  'Bande',
  'Krankenhaus',
  'Roboter',
  'Koks',
  'Karte',
  'Figur',
  'Bergsteiger',
  'Elf',
  'Satellit',
  'Lippe',
  'Akt',
  'Grad',
  'Gift',
  'Gang',
  'Soldat',
  'Bach',
  'Raute',
  'Zoll',
  'Knie',
  'Wurm',
  'Olymp',
  'Schild',
  'Jura',
  'Hotel',
  'Schnur',
  'Gericht',
  'Geschirr',
  'Papier'
]